import React from 'react'
import sematServices from '../../../../../api/sematServicesData'
import SectionTitle from '../../../../Shared/SectionTitle/SectionTitle'
import "./Service.css";





const ServiceSection = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <div className={`wpo-service-area section-padding ${props.sClass}`}>
            <div className="container">
                <SectionTitle subTitle={'Découvrir'} MainTitle={'Nos Services'} />
                <div className="row align-items-center">
                    {sematServices.map((service, sitem) => (
                        <div className="col-lg-4 col-md-6 col-12" key={sitem}>
                            <div className="wpo-service-item">
                                <img src={service.icon} alt="" />
                                <h2>{service.sTitle}</h2>
                                <p>{service.description}</p>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        </div>
    )
}

export default ServiceSection;